import React, { useEffect, useState, useRef } from "react";
import logo from "./logo.svg";
import "./App.css";
import DD from "./Sample";
import Form from "./Form";
import Tran from "./Tran";
import Modal from "./Modal";
import Side from "./SideSheet";
import Table from "./Table";
import Footer from "./component/Footer";
import DropD from "./component/Dropdown";
import CartView from "./component/CartView";
import ViewProduct from "./component/ViewProduct";
import CategoryView from "./component/CategoryItem";
import FAQ from "./component/FAQ";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import {
  Card,
  CardPrice,
  Toggle,
  PlaceholderCard,
  SideCart,
  LandingHeader,
  CategoryPH,
} from "./component";
import { Dialog } from "@headlessui/react";
import { axios } from "./Network";
import FixedDatePicker from "./component/FixedDatePicker";
import ProductCarousel from "./component/ProductCarousel";
import ProductGallery from "./component/ProductGallery";
import CTA from "./component/CTA";
import PricingPlan from "./component/PricingPlan";
import { useMemo } from "react";
import toast, { Toaster } from "react-hot-toast";
import ContentLoader from "react-content-loader";
import moment from "moment";
import momentTZ from "moment-timezone";
import MessengerCustomerChat from "react-messenger-customer-chat";
import ReactGA from "react-ga";
import { fi } from "date-fns/locale";
var timeInManila = momentTZ.tz("Asia/Manila");
var blackFrame =
  "https://localflowershop.sgp1.digitaloceanspaces.com/product/1690550675575-black-frane.png";
//  'https://localflowershop.sgp1.digitaloceanspaces.com/product/1690545518953-smartdesk-black.png'
var whiteFrame =
  "https://localflowershop.sgp1.digitaloceanspaces.com/product/1657637019986-whiteframe.jpeg";

ReactGA.initialize("311891315", {
  debug: true,
  titleCase: false,
  gaOptions: {
    userId: 123,
  },
});
// UA-226511448
var discountedPrice = Number(process.env.REACT_APP_STORE_DISCOUNTED_PRICE); //3000
const MyLoader = (props) => (
  <ContentLoader viewBox="0 0 400 31" height={200} width={"auto"} {...props}>
    <rect height="5.5" rx="1" ry="1" width="340" x="31" y="5" />
    <rect height="5.5" rx="1" ry="1" width="340" x="31" y="15" />
    <circle cx="388" cy="12" r="12" />
    <rect height="24" rx="0" ry="0" width="24" x="0" y="0" />
  </ContentLoader>
);
var id = process.env.REACT_APP_STORE_ID;
var deskFramePrice = 18000; //process.env.REACT_APP_STORE_DESK_FRAME_PRICE

function App() {
  const [selectedColor, setSelectedColor] = useState("black");
  const [status, setStatus] = useState(false);
  const [didCheckout, setCheckout] = useState(true);
  const [suggestStatus, setSuggestStatus] = useState(false);
  const [cart, setCartItems] = useState([]);
  const [showCart, setShowCart] = useState(false);
  let [isOpen, setIsOpen] = useState(true);
  const [scroll, setScroll] = useState(0);
  const [didUpdate, setUpdate] = useState(true);
  const [product, setProducts] = useState([]);
  const [addons, setAddonProduct] = useState([]);
  const [suggestedProduct, setSuggestedProduct] = useState([]);
  const [topItems, setTopItems] = useState([]);
  const [category, setSelectedCategory] = useState("Flux-Bouquet");
  const [categories, setCategory] = useState([]);
  const [storeDetails, setStoreInfo] = useState(null);
  const [hasVoucher, setHasVoucher] = useState(false);
  const [viewProduct, setCurrentView] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const listInnerRef = useRef();
  const [offset, setOffset] = useState(0);
  const [currentPage, setPage] = useState(8);
  const mainCategory = useRef();
  const [isBlack, setFrameColor] = useState(true);
  const [isSelfInstallation, setSelfInstallation] = useState(true);
  const [isPickup, setDeliveryType] = useState(true);
  const [isOwnCar, setIsOwnCar] = useState(true);

  const [tableTop, setSelectedTableTop] = useState("Acacia"); //Acacia
  const [tableSize, setTableSize] = useState("60");

  const [colorFinish, setSelectFinish] = useState({
    title: "Natural Matt",
    imageUrl: "",
    id: "smart-natural",
  });

  const [tableSizeWidth, setTableWidth] = useState("40");
  const [suggesteItem, setSuggestedItem] = useState({
    type: "Lux-Arrangements",
    displayName: "Flower Boxes",
    title: "Lux-Arrangements",
  });
  var addonsID = "Tart-Addons";
  const onScroll = () => {
    // if (listInnerRef.current) {
    //   const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
    //   console.log("reached bottom");
    //   if (scrollTop + clientHeight === scrollHeight) {
    //     console.log("reached bottom");
    //   }
    // }
  };
  const finder = (e) => {
    let userSeletedDate = localStorage.getItem("userQ");
    var date = JSON.parse(userSeletedDate);
    if (e != undefined) {
      var filterd = e.filter(
        (data) =>
          moment(data.date).format("YYYY-MM-DD") ===
          moment(date.date).format("YYYY-MM-DD"),
      );
      if (filterd.length) {
        return filterd[0];
      }
    }
  };
  function hyperLinkFont() {
    return "text-blue-400";
  }
  const setSelectedTableService = (e) => {
    setSelectedTableTop(e);
  };
  const generateCart = () => {
    var installationFee = {
      id: "InstallationFee",
      subtitle: "Service Fee",
      title: "Service Fee ",
      price: "600",
      imgUrl: "http://cdn.onlinewebfonts.com/svg/img_322443.png",
      storeOwner: "5ff00ddaeb2f5d0940dfa186",
      type: "InstallationFee",
      imageDetails: {
        host: "https://nidz.fra1.digitaloceanspaces.com",
        filename: "1621917929948-101.jpg",
        link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      },
    };
    var tableTopD = {
      id: "tabletop",
      subtitle: `Table Top ${getTableDetails(tableTop).title} - (${100 + Number(tableSize) + "cm x " + Number(tableSizeWidth)}cm x 4cm)`,
      title: `Table Top ${getTableDetails(tableTop).title} - (${100 + Number(tableSize) + "cm x " + Number(tableSizeWidth)}cm x 4cm)`,
      price: getTablePricing(tableTop, tableSize, tableSizeWidth), //getTableFramePricing(),
      imgUrl: getTableDetails(tableTop).image,
      storeOwner: "5ff00ddaeb2f5d0940dfa186",
      type: "TableTop",
      imageDetails: {
        host: "https://nidz.fra1.digitaloceanspaces.com",
        filename: "1621917929948-101.jpg",
        link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      },
    };

    //hered
    var tableDeskFrame = [
      {
        id: "60ac80ee9d794c9bdc5363ff",
        subtitle: `SmartDesk Frame \(${selectedColor.toUpperCase()} - ${colorFinish.id})`,
        title: `SmartDesk Frame \(${selectedColor.toUpperCase()})`,
        price: deskFramePrice,
        imgUrl: selectedColor === "white" ? whiteFrame : blackFrame,
        storeOwner: "5ff00ddaeb2f5d0940dfa186",
        type: "SmartDeskFrame",
        imageDetails: {
          host: "https://nidz.fra1.digitaloceanspaces.com",
          filename: "1621917929948-101.jpg",
          link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
        },
      },
      {
        id: "tabletop",
        subtitle: `Table Top ${getTableDetails(tableTop).title} - (${100 + Number(tableSize) + "cm x " + Number(tableSizeWidth)}cm x 4cm)`,
        title: `Table Top ${getTableDetails(tableTop).title} - (${100 + Number(tableSize) + "cm x " + Number(tableSizeWidth)}cm x 4cm) - ${colorFinish.title}  `,
        price: getTablePricing(tableTop, tableSize, tableSizeWidth), //getTableFramePricing(),
        imgUrl: getTableDetails(tableTop).image,
        storeOwner: "5ff00ddaeb2f5d0940dfa186",
        type: "TableTop",
        imageDetails: {
          host: "https://nidz.fra1.digitaloceanspaces.com",
          filename: "1621917929948-101.jpg",
          link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
        },
      },
    ];

    if (!isSelfInstallation) {
      tableDeskFrame.push(installationFee);
    }
    if (tableTop === "none") {
      tableDeskFrame = tableDeskFrame.filter((item) => item != "tabletop");
    } else {
      return tableDeskFrame;
      tableDeskFrame.push(tableTopD); //#3
    }

    //  tableDeskFrame.push(tableTopD) //#
    return tableDeskFrame;
  };

  const getTablePricing = (table, tablesize, width) => {
    // var type = table
    var lenght = 100 + Number(tablesize);
    var width = Number(width);

    switch (table) {
      case "Mahogany":
        var mahoganyprice = 7500;
        if (lenght === 160 && width >= 60) {
          // console.log("160/140/120 x 60", mahoganyprice  + 500)
          return mahoganyprice + 500;
        } else if (lenght >= 180 && width <= 70) {
          //  console.log("180 x 70(below)",8500)
          return 8500;
        } else if (lenght >= 180 && width === 75) {
          // console.log("180 x 75",9000)
          return 9000;
        } else if (lenght >= 180 && width === 80) {
          // console.log("180 x 80",9520)
          return 9520;
        } else {
          console.log("else");
          return mahoganyprice;
        }
        break;
      case "Acacia":
        var acaciaPrice = 6500;
        if (lenght === 160 && width >= 60) {
          return acaciaPrice + 600;
        } else if (lenght === 180 && width <= 70) {
          return acaciaPrice + 1000;
        } else if (lenght >= 180 && width === 75) {
          return acaciaPrice + 1500;
        } else if (lenght >= 180 && width === 80) {
          return acaciaPrice + 2000;
        } else {
          console.log("else");
          return acaciaPrice;
        }
        break;
      case "Jointed-Table":
        var JointedPrice = 5800;
        if (lenght === 160 && width >= 60) {
          return JointedPrice + 500;
        } else if (lenght === 180 && width <= 70) {
          return JointedPrice + 1000;
        } else if (lenght >= 180 && width === 75) {
          return JointedPrice + 1500;
        } else if (lenght >= 180 && width === 80) {
          return JointedPrice + 2000;
        } else {
          return JointedPrice;
        }
        break;
      default:
        return 0;
        break;
    }
  };

  const getTableDetails = (e) => {
    const tables = [
      {
        id: "Acacia",
        title: "Acacia",
        description: "DDD",
        price: "",
        image:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1673064719483-1663398725898-smart-desk-aca%20%281%29.png",
        features: [
          {
            name: "Acacia Solid Wood ",
            description:
              "Acacia wood is known for its natural wood grain variation and distinct beauty. Acacia wood derives from the Australian-native trees and shrubs and produces a solid, durable hardwood that is most commonly used in long-lasting furniture goods.",
          },
          {
            name: "Why choose acacia ",
            description:
              " Acacia has proven itself to be an extremely durable wood. Its density and hardness makes it the perfect material for heavy-use pieces such as computer table top. When properly maintained, these pieces will last decades.",
          },
          {
            name: "What makes it unique?",
            description: `Acacia's durability means it isn't scratched easily, too, while its water-resistant properties means it won't warp readily and is highly resistant to fungus. Like many types of wood, acacia is naturally antibacterial, unlike any other woods.`,
          },
          {
            name: "How to care it?",
            description: `Wipe down the wood with a soft cloth slightly moistened with warm water soapy water. ... Avoid cleaning tools with a rough surface. Don't use detergents or cleaners that have silicone or ammonia in them, as that can dry out the wood and cause cracking.`,
          },
        ],
      },
      {
        id: "Mahogany",
        title: "Mahogany",
        description: "XXXXXX",
        price: "",
        image:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663398559381-smartdesk-mahogany-slab.png",
        features: [
          {
            name: "Mahogany Solid Wood ",
            description: `Mahogany has a straight, fine, and even grain, and is relatively free of voids and pockets. Its reddish-brown color darkens over time, and displays a reddish sheen when polished. It has excellent workability, and is very durable. Historically, the tree's girth allowed for wide boards from traditional mahogany species.`,
          },
          {
            name: "Why choose mahogany?",
            description: `Mahogany is considered one of the most luxurious and beautiful woods in the world, and because of that, it tends to cost more money than other woods.`,
          },
          {
            name: "What makes it unique?",
            description: `Mahogany still one of the most outstanding kinds of wood for handmade furniture, durability, and ability to be carved with the most intricate details—it is truly one of the most beautiful as well.`,
          },
          {
            name: "How to care it?",
            description: `Wipe down the wood with a soft cloth slightly moistened with warm water soapy water * Avoid cleaning tools with a rough surface. * Don't use detergents or cleaners that have silicone or ammonia in them, as that can dry out the wood and cause cracking.`,
          },
        ],
      },
      {
        id: "Jointed-Table",
        title: "Jointed-Table",
        description: "",
        price: "",
        image:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1673064847439-1663399583077-smart-desk-jointer-smart-des%20%281%29.png",
        features: [
          {
            name: "Jointed Table Top",
            description:
              "tables can be built with a “Jointed” smooth table top, which means that those hardwood boards are joined together, creating a smooth, easy-to-clean surface with no tangible open gaps or grooves between them.",
          },
          {
            name: "Why choose jointed-table?",
            description: `Jointed top  creates the appearance of a traditional plank top. There are no actual gaps between the boards, only grooves cut into the top to give the appearance of individual boards.`,
          },
          {
            name: "What makes it unique?",
            description: `Jointing is a process that prepares the edges and faces of boards for gluing to another board. The first jointing tools were long hand planes that removed fine shavings of wood from the surface to flatten it. A number of jointing methods exist today that use hand tools, shop tools or power hand tools.`,
          },
          {
            name: "How to care it?",
            description: `Wipe down the wood with a soft cloth slightly moistened with warm water soapy water * Avoid cleaning tools with a rough surface. * Don't use detergents or cleaners that have silicone or ammonia in them, as that can dry out the wood and cause cracking.`,
          },
        ],
      },
      {
        id: "none",
        title: "None",
        description: "",
        price: "",
        image: "",
        features: [
          { name: "none", description: "" },
          { name: "none", description: "" },
          { name: "none", description: "" },
          { name: "none", description: "" },
        ],
      },
    ];
    return tables.filter(
      (item) => item.id.toLowerCase() === tableTop.toLowerCase(),
    )[0];
  };

  const generateOrder = () => {
    var data = {
      _id: "60ac80ee9d794c9bdc5363ff",
      subtitle:
        "Bobo Balloon with Assorted Flowers (Color of ribbons and balloons can be customized) (38",
      title: "Bobo Balloon Arrangement",
      price: "2500",
      imgUrl:
        "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      storeOwner: "5ff00ddaeb2f5d0940dfa186",
      type: "BoboBalloon",

      imageDetails: {
        host: "https://nidz.fra1.digitaloceanspaces.com",
        filename: "1621917929948-101.jpg",
        link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      },
      objectId: "RANDOM",
    };
    // {"date":"2022-07-08T05:00:05.450Z","type":"FuneralPackages"}
  };
  const getTableSizing = () => {
    var image120 =
      "https://localflowershop.sgp1.digitaloceanspaces.com/product/1656598062407-Web%201920%20%E2%80%93%204.png";
    var image140 =
      "https://localflowershop.sgp1.digitaloceanspaces.com/product/1656598109177-Web%201920%20%E2%80%93%203.png";
    var image160 =
      "https://localflowershop.sgp1.digitaloceanspaces.com/product/1656598611548-Web%201920%20%E2%80%93%202.png";
    var image180 =
      "https://localflowershop.sgp1.digitaloceanspaces.com/product/1656598627993-Web%201920%20%E2%80%93%201.png";
    switch (tableSize) {
      case "20":
        return image120;
        break;
      case "40":
        return image140;
        break;
      case "60":
        return image160;
        break;
      case "80":
        return image180;
        break;
      default:
        return image120;
        break;
    }
  };
  const products = {
    white: {
      big: {
        image1:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650079898624-cc1.png",
        image2:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650075997652-691.png",
      },
      smallBottom: {
        image1:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039298499-502x302.png",
        image2:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039520264-2.png",
      },
      top: {
        image1:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039708120-b23.png",
        image2:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039867851-v1.png",
      },
    },
    black: {
      top: {
        image1:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039708120-b23.png",
        image2:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039867851-v1.png",
      },
      big: {
        image1:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650082192667-bg23.png",
        image2:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650082469034-smallBottom.png",
      },
      smallBottom: {
        image1:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650080756249-bgsma.png",
        image2:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1650082864605-smallBottom%20%281%29.png",
      },
    },
  };
  const validatePreInstallation = () => {
    if (isPickup) {
      return false;
    } else {
      return true;
    }
  };
  const productFilter = (e, state) => {
    var filtered = [];
    console.log("DATA,", e);
    e.map((item) => {
      var price = finder(item.priceSurgesDates);
      if (
        item.priceSurgesDates != undefined &&
        item.priceSurgesDates.length &&
        price != undefined
      ) {
        console.log();
        item.price = price.price;
        filtered.push(item);
      } else {
        filtered.push(item);
      }
    });
    console.log(filtered.length);
    state(filtered);
    setStatus(false);
    setSuggestStatus(false);
  };

  React.useEffect(async () => {
    ReactGA.outboundLink(
      {
        label: `User wanted ${isBlack ? "Black" : "White"} frame`,
      },
      function () {
        console.log("");
      },
      ["tracker2"],
    );
  }, [isBlack]);
  const onClickUrl = (url) => {
    window.open(url, "_blank");
  };
  React.useEffect(async () => {
    console.log("mainCategory", mainCategory.current);
    ReactGA.pageview("Store - Smartdesk 2023" + window.location.search);

    try {
      window.onscroll = () => {
        listInnerRef.current = window.pageYOffset;
        setOffset(window.pageYOffset);
      };
      fetchStoreProduct(category, 8).then((data) => {
        if (data === undefined) {
          toast("Please try again later..");
        } else {
          productFilter(data.data.results, setProducts);
        }
      });
      fetchStoreProduct(suggesteItem.type, 8).then((data) => {
        if (data === undefined) {
          toast("Please try again later..");
        } else {
          console.log("data.data.results", data.data.results);
          productFilter(data.data.results, setSuggestedProduct);
        }
      });
      loadProductCategory();
      let existingCart = localStorage.getItem("UserCart");
      if (existingCart !== null) {
        let jsonCart = JSON.parse(existingCart);
        setCartItems(jsonCart);
      }
    } catch (error) {
      toast("Please try again later..");
    }
  }, []);

  function addRemoveItem(e, status) {
    if (status) {
      setCartItems((prevArray) => [...prevArray, e]);
      let existingCart = cart;
      if (cart.length) {
        let existingCart = localStorage.getItem("UserCart");
        let jsonCart = JSON.parse(existingCart);
        jsonCart.push(e);
        localStorage.setItem("UserCart", JSON.stringify(jsonCart));
      } else {
        let initialCart = [];
        initialCart.push(e);
        localStorage.setItem("UserCart", JSON.stringify(initialCart));
      }
    } else {
      let filteredCart = cart.filter((item) => item._id !== e._id);
      setCartItems(filteredCart);

      localStorage.setItem("UserCart", JSON.stringify(filteredCart));
    }
    setUpdate(true);
  }

  function loadSuggestedOnly(type, page) {
    try {
      fetchStoreProduct(type, page).then((data) => {
        setSuggestedProduct([]);
        productFilter(data.data.results, setSuggestedProduct);
      });
    } catch (error) {
      setSuggestedProduct([]);
    }
  }
  function reload(type, page, withSuggested) {
    if (!withSuggested) {
      mainCategory.current = type;
    }

    setStatus(true);
    setSelectedCategory(type);
    fetchStoreProduct(type, page).then((data) => {
      setProducts([]);
      // setProducts(data.data.results)
      productFilter(data.data.results, setProducts);
      window.scrollTo(0, 1020);
    });
    if (withSuggested) {
      let suggested = categories.filter(
        (data) => data.title != type && data.status == true,
      );
      var item = suggested[Math.floor(Math.random() * suggested.length)];
      try {
        console.log("item", item);
        setSuggestedItem(item);
        fetchStoreProduct(item.title, page).then((data) => {
          setSuggestedProduct([]);
          setSuggestedProduct(data.data.results, setProducts);
        });
      } catch (error) {
        setSuggestedProduct([]);
      }
    }
  }
  function loadProductCategory() {
    let parameter = {
      id: id,
      equalTo: true,
      storeOwner: id,
      cType: "Product",
      cName: "Category",
    };
    axios
      .post("/details/Store", parameter)
      .then((response) => {
        setCategory(response.data.results[0].productCategories);
        // setTopItems(response.data.results[0].topItems)
        setStoreInfo(response.data.results[0]);

        setHasVoucher(
          response.data.results[0].storeOptions.siteHeaderNotice.status,
        );
        document.title = "Smart Desk PH - Your Minimalist Desk"; //response.data.results[0].storeName
      })
      .catch(function (error) {
        console.log("fetching product", error);
      });
  }
  async function fetchStoreProduct(item, page) {
    try {
      var defaultDate = new Date();
      var convertedUserDate = momentTZ(defaultDate)
        .tz("Asia/Manila")
        .format("yyyy-mm-dd");
      let userSeletedDate = localStorage.getItem("userQ");
      var date = JSON.parse(userSeletedDate);
      const data = {
        id: item,
        queryType: "filter",
        storeOwner: "5ff00ddaeb2f5d0940dfa186",
        isAPI: true,
        showLimit: true,
        number: page,
        deliveryDate: moment(date.date).format("YYYY-MM-DD"),
      };
      const response = await axios.post("/productV2/Product", data);
      return response;
    } catch (error) {
      toast("Please try again later..");
    }
  }
  function renderCategories() {
    var data = [];
    categories.map((item) => {
      if (item.status) {
        data.push(
          <CategoryView
            onClick={(e) => reload(e, 8)}
            active={category}
            data={item}
          />,
        );
      }
    });
    return data;
  }
  function renderItem(source) {
    var data = [];
    var sortedProduct = source.sort(
      (a, b) => parseInt(a.price) - parseInt(b.price),
    );
    var sourceItem = sortedProduct;
    var activePromo = storeDetails.storeOptions.activeCategoryPromo[0].category;
    if (sourceItem.length) {
      sourceItem.map((item) => {
        var isAdded =
          cart.filter((data) => data._id === item._id).length === 0
            ? false
            : true;
        data.push(
          <>
            {/* {cadView(item)} */}
            <Card
              activePromo={activePromo}
              type="Display"
              view={(e) => setCurrentView(e)}
              update={didUpdate}
              existing={isAdded}
              item={item}
              didAdd={(item) => addRemoveItem(item, true)}
              didRemove={(item) => addRemoveItem(item, false)}
            />
          </>,
        );
      });
      return data;
    } else {
      for (var i = 0; i < 4; i++) {
        data.push(<PlaceholderCard />);
      }
      return data;
    }
  }

  const displayNotice = () => {
    var content = <div></div>;
    if (
      storeDetails !== null &&
      storeDetails.storeOptions.siteHeaderNotice.status
    ) {
      var details = storeDetails.storeOptions.siteHeaderNotice;
      content = (
        <div
          className="lg:h-15 duration-400 sticky top-0 z-50  flex-1 transform overflow-y-auto transition sm:h-10 "
          style={{ backgroundColor: "#F8EFBA" }}
        >
          <div className="... text-4 mt-2 flex w-full  items-center justify-center font-extralight uppercase  tracking-tight text-gray-900 ">
            {details.value}
          </div>
        </div>
      );
    }

    return content;
  };

  const loadItem = (item, page, primary) => {
    setPage(page);
    if (primary) {
      reload(item, page, false);
    } else {
      loadSuggestedOnly(item, page, true);
      setSuggestStatus(true);
    }
  };

  const validateCart = () => {
    let existingCart = localStorage.getItem("UserCart");
    if (existingCart !== null) {
      let jsonCart = JSON.parse(existingCart);
      console.log(jsonCart.length);
      setCartItems(jsonCart.length == 0 ? [] : jsonCart);
    } else {
      setCartItems([]);
    }
  };
  function displayListofColor() {
    console.log("colorFinish", colorFinish);
    var colors = [
      {
        imageUrl:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663396084364-natural-test.png",
        title: "Natural",
        id: "smart-natural",
      },
      {
        imageUrl:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663396846434-SmartDesk-ColonialMaple.png",
        title: "Colonial",
        id: "smart-colonialmaple",
      },
      {
        imageUrl:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663396782939-SmartDesk-%20Dark%20Wall%20Nut.png",
        title: "dark-wallnut",
        id: "smart-dark-wallnut",
      },
      {
        imageUrl:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663396698966-SmartDesk-Antique%20Cherry.png",
        title: "Antique Cherry",
        id: "AntiqueCherry1",
      },
      {
        imageUrl:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663396592553-SmartDesk-Red%20Oak.png",
        title: "red-oak",
        id: "smart-red-oak",
      },
      {
        imageUrl:
          "https://localflowershop.sgp1.digitaloceanspaces.com/product/1663396545944-SmartDesk-Ebony.png",
        title: "Ebony",
        id: "smart-ebony",
      },
    ];
    if (tableTop === "Acacia") {
      let newList = colors.filter(
        (item) =>
          item.id === "smart-natural" ||
          item.id === "AntiqueCherry1" ||
          item.id === "smart-ebony",
      );
      colors = newList;
    } else if (tableTop === "Jointed-Table") {
      let newList = colors.filter(
        (item) =>
          item.id === "smart-red-oak" ||
          item.id === "smart-ebony" ||
          item.id === "smart-natural",
      );
      colors = newList;
    }

    var itemsDisplay = [];
    colors.map((item) => {
      itemsDisplay.push(
        <a
          key={item.id}
          href={"javascript:void(0);"}
          disa
          onClick={() => setSelectFinish(item)}
          className={
            colorFinish.id === item.id
              ? "delay-80 rounded-md border-2 border-blue-500  transition ease-in-out"
              : "transition delay-150 ease-in-out  "
          }
        >
          <img
            src={item.imageUrl}
            alt={item.title}
            className="z-0 rounded-lg bg-gray-100"
          />
        </a>,
      );
    });

    return itemsDisplay;
  }

  function DisplayColorPicker() {
    var content = (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h1 className="text-3xl tracking-tight  text-gray-900   md:text-5xl">
              Choose your <span className="color-red-200">Table Color</span>
            </h1>
            <p className="text-md mt-4  text-gray-500">
              Ideal finish for{" "}
              <span className="font-bold text-blue-500">
                {" "}
                MAHOGANY | JOINTER
              </span>
              {/* {getTableDetails(tableTop).title}  */}
            </p>
            <h2 className="top-220 sticky left-10  mt-20 text-3xl font-extralight  tracking-tight text-gray-900 sm:text-4xl ">
              {colorFinish.title.toLocaleUpperCase()}
            </h2>
            <div className="mt-40" />
          </div>

          <div className="grid grid-cols-4 grid-rows-2 gap-4  sm:gap-6 lg:gap-8">
            {displayListofColor()}
          </div>
        </div>
      </div>
    );
    return tableTop === "none" ? content : content;
  }

  return (
    <>
      {/* {displayNotice()}  */}
      {1 > 300 ? null : (
        <div className="md:bg-red lg:bg-yellow  bg-black sm:bg-white">
          <FixedDatePicker
            didChangeColor={(e) => setFrameColor(e)}
            validate={() => validateCart()}
            className=""
            tapped={(selectedDate, item) => reload(item, currentPage, true)}
            categories={categories}
            isLoading={status}
          />
        </div>
      )}
      <div class="container mx-auto px-4 py-9 md:px-6 md:py-12"></div>
      {didCheckout ? (
        <CartView
          originalPrice={getDynamicPricingV2()}
          removeItem={(item) => addRemoveItem(item, false)}
          items={generateCart()}
          totalPrice={getDynamicPricing()}
        />
      ) : null}
      <div style={{ opacity: status ? 0.2 : 1 }}>
        <div class="divide-y divide-gray-200">
          <div></div>
        </div>
        <div class="2xl:container 2xl:mx-auto"></div>
        {displayItem()}
        {ProductDetails()} {/* Table */}
        {DisplayColorPicker()}
        {/* {TableSizing()}  */}
        <section class="relative mb-20 mt-20 overflow-hidden rounded-lg pb-80 shadow-2xl lg:m-0 lg:pb-0">
          <div class="ml-auto p-8 text-center sm:p-12 lg:w-2/3">
            <p class="text-sm font-semibold uppercase tracking-widest">
              Run with the pack
            </p>

            <h2 class="mt-6 font-black uppercase">
              <span class="text-5xl font-black sm:text-6xl">
                Easy Billing with BillEase
              </span>
              {/* <span class="mt-2 block text-sm">then surprise them</span> */}
            </h2>

            <a
              class="mt-8 inline-block w-full rounded-full bg-black py-4 text-sm font-bold uppercase tracking-widest text-white"
              href="https://billease.ph/"
            >
              Checkout using BillEase now!
            </a>

            <p class="mt-12 text-xs font-medium uppercase text-gray-400">
              *Simply place your order*
            </p>
          </div>

          <div class="absolute bottom-0  left-0 h-80 w-full lg:h-full lg:w-1/3">
            <img
              alt="Trainer"
              // src="https://z9w3x7q8.rocketcdn.me/wp-content/uploads/2021/05/spotify-app-1024x576.jpg"
              src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1680351675785-Screen%20Shot%202023-04-01%20at%208.21.09%20PM.png"
              class="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        </section>
        {/* {DisplayColorPicker()} */}
        {TableSizing()}
        {deliveryType()}
        {displayPreInstallted()}
        {storeDetails !== null ? (
          <Footer details={storeDetails} />
        ) : (
          <MyLoader />
        )}
        <MessengerCustomerChat
          pageId="100632342493724"
          appId="459290835669103"
        />
      </div>
    </>
  );
  function displayFrameNote() {
    if (tableTop != "none" && (tableSize === "60" || tableSize === "80")) {
      return tableTop === "none" ? null : (
        <span className="text-xs text-gray-400 transition ease-in-out">
          {" "}
          * There will be an additional fee for every succeeding 20cm of length
          above 140cm{" "}
        </span>
      );
    } else {
      return null;
    }
  }
  function getDynamicPricing(isOriginal) {
    var tableTopPrice =
      tableTop === "none"
        ? 0
        : getTablePricing(tableTop, tableSize, tableSizeWidth); //#3
    var framePrice = 18000;
    var additionalPricing = 0; //500 #3
    var preInstallationFee = !isSelfInstallation ? 600 : 0;
    var totalAdditionalFee =
      preInstallationFee +
      tableTopPrice +
      (tableTop === "none" ? 0 : +additionalPricing);
    var totalAdditionalFee180 =
      preInstallationFee + tableTopPrice + (tableTop === "none" ? 0 : +1000);
    if (tableSize === "60") {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(framePrice + totalAdditionalFee - discountedPrice);
    } else if (tableSize === "80") {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(framePrice + totalAdditionalFee180 - discountedPrice);
    } else {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(
        framePrice + preInstallationFee + tableTopPrice - discountedPrice,
      );
    }
  }

  function getDynamicPricingV2() {
    var tableTopPrice =
      tableTop === "none"
        ? 0
        : getTablePricing(tableTop, tableSize, tableSizeWidth); //#3
    var framePrice = 18000;
    var additionalPricing = 0; //500 #3
    var preInstallationFee = !isSelfInstallation ? 600 : 0;
    var totalAdditionalFee =
      preInstallationFee +
      tableTopPrice +
      (tableTop === "none" ? 0 : +additionalPricing);
    var totalAdditionalFee180 =
      preInstallationFee + tableTopPrice + (tableTop === "none" ? 0 : +1000);
    if (tableSize === "60") {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(framePrice + totalAdditionalFee);
    } else if (tableSize === "80") {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(framePrice + totalAdditionalFee180);
    } else {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(framePrice + preInstallationFee + tableTopPrice);
    }
  }

  function displayTableFee() {
    if (tableTop != "none") {
      var itemsfee = [];
      {
        ["Solid Wood Table Top Price Fee - ₱5500"].map((item) =>
          itemsfee.push(
            <p className="text-tiny font-extralight text-gray-500">{item}</p>,
          ),
        );
        return <div className="ml-2">{itemsfee}</div>;
      }
    }
  }

  function ProductDetails() {
    return (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h1 className="text-3xl tracking-tight  text-gray-900   md:text-5xl ">
              Choose your Table Top
            </h1>
            {/* <h1 className="md:text-5xl text-3xl  tracking-tight  animate-bounce text-red-500">Out of stock!</h1> */}
            <h2 className="top-220 sticky left-10 mt-20 text-3xl font-medium  tracking-tight text-gray-900 sm:text-4xl ">
              {getTableDetails(tableTop).title}
            </h2>

            <h3 className="mb-5 mt-2 flex text-xs   leading-5 text-black">
              {moment().add(3, "w").format("MMMM DD, YYYY").toString()}
              <img
                src="https://img.icons8.com/material-outlined/344/calendar--v1.png"
                className="mx-2 mt-1 h-4 w-4"
              />
              (Date of Completion)
            </h3>

            {tableTop != "none" ? (
              <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
                {getTableDetails(tableTop).features.map((feature) => (
                  <div
                    key={feature.name}
                    className="border-t border-gray-200 pt-4"
                  >
                    <dt
                      className={`font-medium   ${tableTop === "none" ? "text-gray-200" : "text-gray-900"}`}
                    >
                      {feature.name}
                    </dt>
                    <dd
                      className={`mt-2 text-sm  ${tableTop === "none" ? "text-gray-200" : "text-gray-500"}`}
                    >
                      {feature.description}
                    </dd>
                  </div>
                ))}
              </dl>
            ) : null}
            {/* {tableTop != 'none' ? ` Table Price ${new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(getTablePricing(tableTop,tableSize,tableSizeWidth)) }`: null}   */}
            <div
              className={`mt-20 ${tableTop === "none" ? "opacity-20" : "opacity-100"}`}
            >
              <label
                for="default-range"
                class="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Table length:{" "}
                <span className="text-sm text-gray-500">
                  {100 + Number(tableSize)}cm
                </span>{" "}
              </label>
              <div class="">
                <input
                  type="range"
                  disabled={tableTop === "none" ? true : false}
                  list="tickmarks"
                  step="10"
                  min={20}
                  max={60}
                  onChange={(value) => setTableSize(value.target.value)}
                  class="w-full rounded-lg bg-gray-400 dark:bg-gray-700"
                />
                <datalist id="tickmarks">
                  <option value="20"></option>
                  <option value="40"></option>
                  <option value="60"></option>
                  <option value="80"></option>
                </datalist>
              </div>
              <div class="">
                <label
                  for="default-range"
                  class="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Table width:{" "}
                  <span className="text-sm text-gray-500">
                    {Number(tableSizeWidth)}cm
                  </span>{" "}
                </label>
                <input
                  type="range"
                  disabled={tableTop === "none" ? true : false}
                  list="tableWidth"
                  step="5"
                  min={60}
                  max={80}
                  onChange={(value) => setTableWidth(value.target.value)}
                  class="w-full rounded-lg bg-gray-400 dark:bg-gray-700"
                />
                <datalist id="tableWidth">
                  <option value="60"></option>
                  <option value="65"></option>
                  <option value="70"></option>
                  <option value="75"></option>
                  <option value="80"></option>
                </datalist>
              </div>
            </div>
            <div
              className={`mt-5 ${tableTop === "none" ? "opacity-20" : "opacity-100"}`}
            >
              {100 + Number(tableSize) + "cm x " + Number(tableSizeWidth)}cm x
              4cm{" "}
            </div>
          </div>
          <div className="grid grid-cols-2 grid-rows-2 gap-4 opacity-100 sm:gap-6 lg:gap-8">
            <a
              href={"javascript:void(0);"}
              onClick={() => setSelectedTableService("Mahogany")}
              className={
                tableTop === "Mahogany"
                  ? "delay-20 rounded-md border-2 border-blue-500  transition ease-in-out"
                  : "transition delay-150 ease-in-out  "
              }
            >
              <img
                src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1663398559381-smartdesk-mahogany-slab.png"
                alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
                className="rounded-lg bg-gray-100"
              />
            </a>
            <a
              href="javascript:void(0);"
              onClick={() => setSelectedTableService("Acacia")}
              className={
                tableTop === "Acacia"
                  ? "delay-20 rounded-md border-2 border-blue-500  transition ease-in-out"
                  : "transition delay-150 ease-in-out  "
              }
            >
              <img
                src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1673064719483-1663398725898-smart-desk-aca%20%281%29.png"
                alt="Top down view of walnut card tray with embedded magnets and card groove."
                className="rounded-lg bg-gray-100"
              />
            </a>
            <a
              href="javascript:void(0);"
              onClick={() => setSelectedTableService("Jointed-Table")}
              className={
                tableTop === "Jointed-Table"
                  ? "delay-20 rounded-md border-2 border-blue-500  transition ease-in-out"
                  : "transition delay-150 ease-in-out  "
              }
            >
              <img
                src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1673064847439-1663399583077-smart-desk-jointer-smart-des%20%281%29.png"
                alt="Side of walnut card tray with card groove and recessed card area."
                className="rounded-lg bg-gray-100"
              />
            </a>
            {/* <a     href= 'javascript:void(0);'  onClick={()=>setSelectedTableService('none')}  className={tableTop === 'none'? 'border-blue-500 transition ease-in-out delay-20  border-2 rounded-md text-center justify-center ': 'transition ease-in-out delay-150 text-center '}>
            <h1 className="font-xs text-xs text-gray-900 mt-28  ">I don't need table top</h1>
            </a> */}
          </div>
          <button
            type="button"
            class="ease focus:shadow-outline m-2 lg:mb-10 select-none rounded-full border border-black bg-black px-4 py-2 text-white transition duration-500 hover:bg-gray-800 focus:outline-none"
          >
            {" "}
            {discountedPrice != 0 ? (
              <span className="mr-2 text-red-600 line-through">
                {getDynamicPricingV2()}
              </span>
            ) : null}
            {getDynamicPricing()}
          </button>
          <button
            onClick={() =>
              onClickUrl(
                "https://www.lazada.com.ph/products/standing-desk-dual-motor-with-solid-wood-jointer-mahogany-table-top-smartdeskph-i3290383845-s26391804337.html?",
              )
            }
            type="button"
            class="font-bold text-blue-700  ease focus:shadow-outline m-2 mb-10 select-none rounded-full border border-black bg-white px-4 py-2 text-black transition duration-500 hover:bg-gray-200 focus:outline-none"
          >
            Checkout via LAZADA
          </button>
          {displayFrameNote()}
        </div>
      </div>
    );
  }
  function displayInstallationFee() {
    if (!isSelfInstallation) {
      var itemsfee = [];
      {
        ["Service Fee - ₱600 (Discounted)"].map((item) =>
          itemsfee.push(
            <p className="text-md mt-1 font-extralight text-gray-500">
              {item}
            </p>,
          ),
        );
        return <div className="ml-2">{itemsfee}</div>;
      }
    }
  }

  function deliveryPickupDetails() {
    if (!isPickup) {
      var itemsfee = [];
      {
        ["Item Sealed", "2 boxes", "Delivery shoulder by customer"].map(
          (item) =>
            itemsfee.push(
              <p className="text-tiny mt-1 font-extralight text-gray-500">
                {item}
              </p>,
            ),
        );
        return (
          <div
            class="border-l-4 border-blue-900 bg-orange-100 p-4 text-orange-700"
            role="alert"
          >
            <p class="font-bold">For Delivery</p>
            {/* <p>Something not ideal might be happening.</p> */}
            <div className="">{itemsfee}</div>
            <p class="mt-10 font-bold ">Date of Delivery</p>
            <p className="text-tiny font-extralight text-gray-500">
              {moment().add(3, "w").format("MMM DD, YYYY").toString()}{" "}
            </p>
          </div>
        );

        //
      }
    } else {
      return (
        <div
          class="border-l-4 border-blue-900 bg-orange-100 p-4 text-orange-700"
          role="alert"
        >
          <p class="font-bold ">For Pickup</p>
          <p className="text-tiny font-extralight text-gray-500">
            Main Ave, P Tuazon, Cubao Quezon City, Philippines{" "}
          </p>
          <p class="mt-10 font-bold ">Date of Pickup</p>
          <p className="text-tiny font-extralight text-gray-500">
            {moment().add(3, "w").format("MMM DD, YYYY").toString()}{" "}
          </p>
        </div>
      );
    }
  }
  function validateTypeOfDelivery(e) {
    setSelfInstallation(true);
    setIsOwnCar(e);
    setDeliveryType(e);

    ReactGA.event({
      category: "Pickup Or DtoDoor",
      action: `value ${isPickup ? "Pickup" : "Door to Door"}`,
      label: `value ${isPickup ? "Pickup" : "Door to Door"}`,
    });
  }
  function validateOwnVehicle(e) {
    setSelfInstallation(true);
    setIsOwnCar(e);
  }

  function deliveryType() {
    return (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h1
              className={`text-3xl  tracking-tight  text-gray-900   md:text-5xl `}
            >
              Pickup or Delivery?
            </h1>

            <p className="mt-4 text-base text-gray-500">
              Let us know, for us to arrange according to our convenience.
            </p>

            <div className="mt-20" style={{ marginLeft: "1%" }}>
              <button
                onClick={() => validateTypeOfDelivery(true)}
                className={
                  isPickup
                    ? "rounded-full border-2 border-white bg-black text-white transition ease-in-out "
                    : `${hyperLinkFont()} `
                }
              >
                <span className=" ml-2 mr-2 font-light">Pickup</span>
              </button>
              <button
                onClick={() => validateTypeOfDelivery(false)}
                className={
                  isPickup === false
                    ? "rounded-full border-2 border-white bg-black text-white transition ease-in-out "
                    : ` ${hyperLinkFont()} rounded-full transition ease-in-out`
                }
              >
                <span className="ml-2 mr-2 font-light ">
                  Door to Door Delivery (NCR){" "}
                </span>
              </button>
            </div>
            <div class="col justify-center">
              <div>
                <p
                  className="mt-10 text-gray-500"
                  style={{
                    opacity: !isPickup ? 0.2 : 1,
                    display: isPickup ? "flex" : "none",
                  }}
                >
                  When picking up, what do you want to use?
                </p>
                <div
                  className="mt-5"
                  style={{
                    opacity: !isPickup ? 0.2 : 1,
                    display: isPickup ? "flex" : "none",
                  }}
                >
                  <button
                    onClick={() => validateOwnVehicle(true)}
                    className={
                      isOwnCar
                        ? `rounded-full border-2 border-white bg-black text-white transition ease-in-out  `
                        : `${hyperLinkFont()} `
                    }
                  >
                    <span className={` ml-2 mr-2 font-light `}>
                      Own Vehicle
                    </span>
                  </button>
                  <button
                    onClick={() => validateOwnVehicle(false)}
                    className={
                      isOwnCar === false
                        ? "rounded-full border-2 border-white bg-black text-white transition ease-in-out "
                        : `rounded-full ${hyperLinkFont()} transition ease-in-out`
                    }
                  >
                    <span className="ml-2 mr-2 font-light ">
                      Any Transport Courier
                    </span>
                  </button>
                </div>
                {displayNoticePreAssemble()}
              </div>
            </div>
            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              {deliveryPickupDetails()}
            </dl>
          </div>

          <div className="grid grid-cols-2 grid-rows-2 gap-4 sm:gap-6 lg:gap-8"></div>
        </div>
      </div>
    );
  }

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  function displayNoticePreAssemble() {
    //   if (!isOwnCar && !isPickup) {
    //     return   <div class="bg-orange-100 border-l-4 mt-10 border-blue-900 text-orange-700 p-4" role="alert">
    //   <p class="font-bold ">Pre assemble disabled</p>
    //   <p className='text-gray-500 text-tiny font-extralight'>To protect the motor of the standing desk, We discourage our pre installation method using any delivery carrier services.</p>
    // </div>
    //   }
  }
  function displayPreInstallted() {
    return (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h1 className="text-3xl tracking-tight  text-gray-900  md:text-5xl">
              Desk arrangement setup
            </h1>

            <p className="mt-4 text-base text-gray-500">
              The Client has an option to book their own delivery service when
              choosing{" "}
              <span className="font-bold text-red-500">pre-assemble</span>..
              However, for any damages or losses, SmartDeskPh will not be
              responsible.*
              {/* Client has an option to book their own delivery service when choosing <span className='font-bold text-red-500'>pre-assemble</span>. However, for any damages or losses, SmartDeskPh will not be responsible.* */}
            </p>
            <div
              className="mt-20"
              style={{ marginLeft: "15%" }}
              styles={{ flex: "column" }}
            >
              <button
                onClick={() => setSelfInstallation(true)}
                className={
                  isSelfInstallation
                    ? "rounded-full border-2 border-white bg-black text-white transition ease-in-out "
                    : `${hyperLinkFont()}`
                }
              >
                <span className=" ml-2 mr-2 font-light">
                  DIY (Do it by your self){" "}
                </span>
              </button>
              {/* <div styles={{opacity:!isPickup ? 0.2 : 1}}> */}
              <button
                disabled={!validatePreInstallation()}
                onClick={() => setSelfInstallation(false)}
                className={
                  !isSelfInstallation
                    ? "rounded-full border-2 border-white bg-black text-white transition ease-in-out "
                    : validatePreInstallation()
                      ? `rounded-full ${hyperLinkFont()} transition ease-in-out`
                      : "rounded-full text-gray-400 transition ease-in-out"
                }
              >
                <span className="ml-2 mr-2 font-light ">PRE-ASSEMBLE</span>
              </button>
              {/* </div> */}
            </div>
            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              {displayInstallationFee()}
            </dl>
            {/* <p className="mt-4 text-gray-500 text-base " style={{display:isSelfInstallation ? 'none' : ''}}>
         When in Pre-assemble, client has an option to book their own delivery service when choosing <span className='font-bold text-red-500'>Pre-assemble</span>. However, for any damages or losses during dispatching and unloading, SmartDeskPh will not be responsible.*
          </p>  */}
            {/* {!validatePreInstallation() ?    <div class="bg-orange-100 border-l-4 border-blue-900 text-orange-700 p-4" role="alert">
        <p class="font-bold ">Pre assemble disabled</p>
        <p className='text-gray-500 text-tiny font-extralight'>To protect the motor of the standing desk, We discourage our pre installation method using any delivery carrier services.</p>
      </div> : null } */}
          </div>

          <div className="grid grid-cols-2 grid-rows-2 gap-4 sm:gap-6 lg:gap-8"></div>
          <button
            onClick={() => setCheckout(true)}
            type="button"
            class="ease focus:shadow-outline m-2 lg:mb-20 mb-2 select-none rounded-full border border-black bg-white px-4 py-2 text-black transition duration-500 hover:bg-gray-200 focus:outline-none"
          >
            Checkout :{" "}
            {discountedPrice != 0 ? (
              <span className="text-red-600 line-through">
                {getDynamicPricingV2()}
              </span>
            ) : null}{" "}
            {getDynamicPricing()}
          </button>

          <button
            onClick={() =>
              onClickUrl(
                "https://www.lazada.com.ph/products/standing-desk-dual-motor-with-solid-wood-jointer-mahogany-table-top-smartdeskph-i3290383845-s26391804337.html?",
              )
            }
            type="button"
            class="font-bold text-blue-700 ease focus:shadow-outline m-2 mb-20 select-none rounded-full border border-black bg-white px-4 py-2 text-black transition duration-500 hover:bg-gray-200 focus:outline-none"
          >
            Checkout via LAZADA
          </button>
        </div>
      </div>
    );
  }

  function didScrollTableSize(value) {
    ReactGA.event({
      category: "Store Table Frame",
      action: "Scroll Table Size Frame",
      label: `value ${value.target.value}`,
    });
    setTableSize(value.target.value);
  }

  function TableSizing() {
    return (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            {/* <h2 className="text-3xl font-extralight tracking-tight text-gray-900 sm:text-4xl sticky  top-220 left-10 ">Lenght Specifications</h2> */}
            <h1 className="text-3xl tracking-tight  text-gray-900   md:text-5xl">
              Tell us your preferred size.
            </h1>
            {/* <p className="mt-4 text-gray-500">
              The walnut wood card tray is precision milled to perfectly fit a stack of Focus cards. The powder coated
              steel divider separates active cards from new ones, or can be used to archive important task lists.
            </p> */}

            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              {deskTechnicalFeature.map((feature) => (
                <div
                  key={feature.name}
                  className="border-t border-gray-200 pt-4"
                >
                  <dt className="text-sm font-medium text-gray-900">
                    {feature.name}
                  </dt>
                  <div className="mt-2 text-xs text-gray-500">
                    {feature.description}
                  </div>
                </div>
              ))}
            </dl>
            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              <div>
                <label
                  for="default-range"
                  class="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Table length:{" "}
                  <span className="text-sm text-gray-500">
                    {100 + Number(tableSize)}cm
                  </span>{" "}
                </label>

                <div class="">
                  <input
                    type="range"
                    list="tickmarks"
                    step="10"
                    min={20}
                    max={60}
                    onChange={(value) => didScrollTableSize(value)}
                    class="w-full rounded-lg bg-gray-400 dark:bg-gray-700"
                  />
                  <datalist id="tickmarks">
                    <option value="20"></option>
                    <option value="40"></option>
                    <option value="60"></option>
                    <option value="80"></option>
                  </datalist>
                </div>
              </div>
            </dl>
          </div>
          <div className="grid ">
            <img
              src={getTableSizing()}
              alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
              className="duration-400 h-full w-full transform rounded-lg bg-gray-100 transition"
            />
          </div>
          <button
            type="button"
            class="ease  focus:shadow-outline m-2 select-none rounded-full border border-black bg-black px-4 py-2 text-white transition duration-500 hover:bg-gray-800 focus:outline-none"
          >
            {discountedPrice != 0 ? (
              <span className="text-red-600 line-through">
                {getDynamicPricingV2()}
              </span>
            ) : null}
            {getDynamicPricing()}
          </button>
          <button
            onClick={() =>
              onClickUrl(
                "https://www.lazada.com.ph/products/standing-desk-dual-motor-with-solid-wood-jointer-mahogany-table-top-smartdeskph-i3290383845-s26391804337.html?",
              )
            }
            type="button"
            class="font-bold text-blue-700 mt-10 ease focus:shadow-outline m-2 mb-10 select-none rounded-full border border-black bg-white px-4 py-2 text-black transition duration-500 hover:bg-gray-200 focus:outline-none"
          >
            Checkout via LAZADA
          </button>
          {displayFrameNote()}

          {/* {tableTop === 'none'? null: <span>Greater than 140cm: Additional fee for every succeding 20cm</span> }  */}
          {/* <div className='flex '>
          <label for="default-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Table length <span className="text-sm text-gray-500">{(100+Number(tableSize))}cm</span> </label>
      <input id="default-range" type="range"  step="20" min={20} max={80} onChange={(value)=>setTableSize(value.target.value)} value={tableSize}class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"></input>
</div> */}
        </div>
      </div>
    );
  }
  const displaySaleImage = () => {
    // return
    {
      /* <img
  src={'https://messonghi-corfuboats.com/wp-content/uploads/2020/06/10-percent-off-stamp-png.png'}
  alt={product.imageAlt}
  className="w-auto h-20"
  style={{position:'absolute',top:0,left:20}}
/> */
    }
  };
  function displayItem() {
    var productDetails = [
      "Dual Silent Motor",
      "120-180cm",
      "Overload Protection",
      "Lifting Speed 35mm/s",
      "Max 100KG",
      "Output voltage：Max 32VDC",
      "Duty Cycle：10% Max",
    ];
    const products = [
      {
        id: 1,
        name: "Premium White Frame",
        href: "javascript:void(0);",
        imageSrc: whiteFrame,
        imageAlt: "Standing Desk Frame White",
        price: "18000",
        color:
          "16-core Neural Engine 13.6-inch Liquid Retina display with True Tone 1080p FaceTime HD camera MagSafe 3 charging port Two Thunderbolt / USB 4 ports Magic Keyboard with Touch ID Force Touch trackpad 30W USB-C Power Adapter ",
        details: productDetails,
      },
    ];
    const black = [
      {
        id: 1,
        name: "Premium Black Frame",
        href: "javascript:void(0);",
        imageSrc: blackFrame,
        imageAlt: "Standing Desk Frame",
        price: "18000",
        color:
          "16-core Neural Engine 13.6-inch Liquid Retina display with True Tone 1080p FaceTime HD camera MagSafe 3 charging port Two Thunderbolt / USB 4 ports Magic Keyboard with Touch ID Force Touch trackpad 30W USB-C Power Adapter ",
        details: productDetails,
      },
    ];

    var sss = selectedColor === "white" ? products : black;
    return (
      <div className="flex justify-center bg-white">
        <div className="mx-auto  max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
          <div className="mb-20">
            <a
              className="rounded-full border-2 border-white bg-black text-white transition ease-in-out "
              href="https://smartdeskph.com"
            >
              <span className=" ml-2 mr-2 font-light">Back to home </span>
            </a>
          </div>
          <h1 className="text-3xl font-extralight  tracking-tight text-gray-900 md:text-5xl">
            Standing Desk Frame
          </h1>

          <div className="mt-6 flex justify-center ">
            {sss.map((product) => (
              <div key={product.id} className="group relative">
                <div className="aspect-w-1 aspect-h-1  lg:aspect-none min-h-80 w-full overflow-hidden rounded-md bg-gray-200 group-hover:opacity-75 lg:h-80">
                  <img
                    src={product.imageSrc}
                    alt={product.imageAlt}
                    className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                  />
                </div>
                <div className="mt-4 flex justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-gray-700">
                      <a href={product.href}>
                        <span
                          aria-hidden="true"
                          className="absolute inset-0 "
                        />
                        {product.name}
                      </a>
                    </h3>
                    {product.details.map((items) => (
                      <p className="text-tiny mt-1 text-sm font-extralight text-gray-500">
                        {items}
                      </p>
                    ))}
                  </div>

                  {/* <p className="line-through text-sm font-medium text-gray-900 ">
                {new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(product.price ) }
                  </p> */}

                  {/* <p className="text-sm font-medium text-red-500 ml-2">{new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(product.price - discountedPrice) }</p> */}
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginLeft: 20 }}>
            <button
              onClick={() => setSelectedColor("black")}
              type="button"
              class="ease focus:shadow-outline m-2 ml-20 select-none rounded-full border border-black bg-black px-4 py-4 text-white transition duration-500 hover:bg-gray-200 focus:outline-none"
            />
            <button
              disabled={false}
              // setSelectedColor('white')
              onClick={() => setSelectedColor("white")}
              type="button"
              class={` ease focus:shadow-outline m-2 select-none rounded-full bg-gray-200 px-4 py-4 text-white transition duration-500 hover:bg-gray-200 focus:outline-none ${selectedColor === "white" ? "border-2 border-blue-900" : "border-2 border-black"}`}
            />
          </div>
        </div>
      </div>
    );
  }
}

const deskTechnicalFeature = [
  { name: "Type", description: "Dual Silent Motor Black" },
  { name: "Frame length", description: "120-180cm" },
  { name: "Feature", description: "Overload Protection" },
  { name: "Speed", description: "Lifting Speed 35mm/s" },
  { name: "Maximum load", description: "Max 100KG" },
  { name: "Voltage", description: "Output voltage：Max 32VDC" },
];
export default App;
